import { createFileRoute, redirect } from "@tanstack/react-router";

import { buildLocalizedPagePath } from "@/lib/localized-page-path";

export const Route = createFileRoute("/stores")({
  beforeLoad: ({ context: { locale } }) => {
    throw redirect({ href: buildLocalizedPagePath(locale, "stores"), statusCode: 301 });
  },
});
